var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-alert",class:[
    _vm.outlined ? 'app-alert__border-positive' : null,
    `bg-${_vm.variant}`,
    _vm.rounded ? 'app-alert__rounded' : null,
  ]},[_c('p',{staticClass:"text-bold"},[_vm._t("title")],2),_c('p',{staticClass:"flex items-center justify-center q-gutter-x-xs",class:[_vm.bold ? 'text-bold' : null]},[_vm._t("icon"),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._t("default")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }